import { Dayjs } from 'dayjs'

import { SupportedPageKey, usePageDrawer } from '~/hooks/usePageDrawer'
import { TabValue } from '~/store/slices/selectionDrawerSlice'
import { useStore } from '~/store/store'
import { Location } from '~/storm'

export const useSelectionDrawer = () => {
    const { openPageDrawer, closePageDrawer } = usePageDrawer()
    const selectionDrawer = useStore(state => state.selectionDrawer)
    const { actions: drawerActions } = selectionDrawer

    // Read fresh at call time so we don't close over stale render values.
    const resolveClosePageDrawerOnClose = (pageWasOpen: boolean) => {
        const { closePageDrawerOnClose, isDrawerOpen } = useStore.getState().selectionDrawer
        return pageWasOpen ? (closePageDrawerOnClose ?? isDrawerOpen) : true
    }

    const handleClose = () => {
        // Capture before closeDrawer(), which resets closePageDrawerOnClose.
        const { closePageDrawerOnClose } = useStore.getState().selectionDrawer
        drawerActions.closeDrawer()
        if (closePageDrawerOnClose === true) {
            closePageDrawer()
        }
    }

    const actions = {
        ...drawerActions,
        closeDrawer: handleClose,
    }

    const openDateSelectionWithPageDrawer = (date: Dayjs, activeDrawerTab?: TabValue) => {
        const pageWasOpen = openPageDrawer()
        drawerActions.openDrawer({ type: 'scheduleDate', date }, resolveClosePageDrawerOnClose(pageWasOpen))
        if (activeDrawerTab) {
            drawerActions.setActiveDrawerTab(activeDrawerTab)
        }
    }

    const openLocationDateSelectionWithPageDrawer = (
        date: Dayjs,
        locationId: Location['id'],
        pageDrawerOptions?: { pageKey?: SupportedPageKey | undefined }
    ) => {
        const pageWasOpen = openPageDrawer({ openDrawerArgs: { date, locationId }, activeDrawerTab: 'comments', ...pageDrawerOptions })
        drawerActions.openDrawer({ type: 'locationDate', date, locationId }, resolveClosePageDrawerOnClose(pageWasOpen))
    }

    return {
        ...selectionDrawer,
        actions,
        openDateSelectionWithPageDrawer,
        openLocationDateSelectionWithPageDrawer,
    }
}
